import React, { Component } from "react";

import { BookingStatus, UserRole, FreightMode, UserType, titlePrefix } from "@assets/constants";
import {
  TableInfo,
  UserProfileViewModel,
  ActiveRequest,
  ActiveBooking,
  Currency,
} from "@assets/types";
import { WindowUtilities } from "@assets/utilities";
import ContactButton from "@components/Button/contactButton";
import MapCard from "@components/Card/mapCard";
import TableCard from "@components/Card/tableCard";
import Link from "@components/Link/link";
import AuthService from "@services/AuthService";
import {
  fetchActiveAirFreightBookings,
  fetchActiveSeaFreightBookings,
  fetchActiveRequests,
  fetchLatestCurrencies,
} from "@state/actions/index";
import { AppState } from "@state/reducers/types";
import "currency-flags/dist/currency-flags.min.css";
import i18n from "i18next";
import { Trans, Translation } from "react-i18next";
import { FaSpinner } from "react-icons/fa";
import { FiRefreshCcw } from "react-icons/fi";
import { connect } from "react-redux";

import styles from "./master.module.less";

const OldServiceWeb = process.env.OldServiceWeb;
class Master extends Component<
  {
    path?: string;
    fetchActiveAirFreightBookings: Function;
    fetchActiveSeaFreightBookings: Function;
    fetchActiveRequests: Function;
    fetchLatestCurrencies: Function;
    userProfile: UserProfileViewModel;
    activeRequests: ActiveRequest[];
    loadingRequests: boolean;
    activeSeaFreightBookings: ActiveBooking[];
    loadingSeaFreightBookings: boolean;
    activeAirFreightBookings: ActiveBooking[];
    loadingAirFreightBookings: boolean;
    latestCurrencies: Currency[];
    loadingCurrencies: boolean;
  },
  {}
> {
  async componentDidMount() {
    document.title = titlePrefix + i18n.t("MENU_HOME");
    await this.props.fetchActiveAirFreightBookings(
      this.props.userProfile.SelectedCompany.PartnerCode
    );
    await this.props.fetchActiveSeaFreightBookings(
      this.props.userProfile.SelectedCompany.PartnerCode
    );
    await this.props.fetchActiveRequests(this.props.userProfile.SelectedCompany.PartnerCode);
    await this.props.fetchLatestCurrencies();
  }

  async componentDidUpdate(prevProps: { userProfile?: UserProfileViewModel }) {
    if (
      prevProps.userProfile &&
      this.props.userProfile.SelectedCompany.PartnerCode !==
        prevProps.userProfile.SelectedCompany.PartnerCode
    ) {
      await this.props.fetchActiveAirFreightBookings(
        this.props.userProfile.SelectedCompany.PartnerCode
      );
      await this.props.fetchActiveSeaFreightBookings(
        this.props.userProfile.SelectedCompany.PartnerCode
      );
      await this.props.fetchActiveRequests(this.props.userProfile.SelectedCompany.PartnerCode);
    }
  }

  render() {
    const airTravel: TableInfo = {
      tableHeader: [
        i18n.t("LABEL_BOOKING"),
        i18n.t("LABEL_BOL"),
        i18n.t("LABEL_STATUS"),
        i18n.t("LABEL_CUSTOMSCLEARED"),
      ],
      tableData: this.props.activeAirFreightBookings.map((booking, i) => {
        return [
          <Link
            key={i}
            onClick={() =>
              WindowUtilities.navigatePage(
                `/singleBooking/${FreightMode.AI}/${booking.JobReference}`
              )
            }
          >
            {booking.JobReference.toString()}
          </Link>,
          booking.Reference,
          i18n.t("BOOKINGSTATUS_" + BookingStatus[booking.Status]),
          booking.IsCustomsCleared ? i18n.t("TEXT_YES") : i18n.t("TEXT_NO"),
        ];
      }),
      classes: ["", "hidden md:table-cell", "", ""],
    };

    const seaTravel: TableInfo = {
      tableHeader: [
        i18n.t("LABEL_BOOKING"),
        i18n.t("LABEL_VOYAGEREFERENCE"),
        i18n.t("LABEL_STATUS"),
        i18n.t("LABEL_CUSTOMSCLEARED"),
      ],
      tableData: this.props.activeSeaFreightBookings.map((booking, i) => {
        return [
          <Link
            key={i}
            onClick={() =>
              WindowUtilities.navigatePage(
                `/singleBooking/${FreightMode.SH}/${booking.JobReference}`
              )
            }
          >
            {booking.JobReference.toString()}
          </Link>,
          booking.Reference,
          i18n.t("BOOKINGSTATUS_" + BookingStatus[booking.Status]),
          booking.IsCustomsCleared ? i18n.t("TEXT_YES") : i18n.t("TEXT_NO"),
        ];
      }),
      classes: ["", "hidden md:table-cell", "", ""],
    };

    const requestTravel: TableInfo = {
      tableHeader: [
        i18n.t("LABEL_REQUEST"),
        i18n.t("LABEL_BOOKING"),
        i18n.t("LABEL_STATUS"),
        i18n.t("LABEL_TYPE"),
      ],
      tableData: this.props.activeRequests.map((request) => {
        return [
          <Link
            key={request.ID}
            onClick={() =>
              window.open(
                `${OldServiceWeb}/DisplayBookingInquiry.aspx?ReqNo=${request.ID}`,
                "_blank",
                "location=yes,height=780,width=800,scrollbars=yes,status=yes"
              )
            }
          >
            {request.ID.toString()}
          </Link>,
          <Link
            className="text-left"
            key={request.JobReference}
            onClick={() =>
              WindowUtilities.openTabOrWindow(
                `/singleBooking/${request.BookingFreightMode}/${request.JobReference}#Requests`
              )
            }
          >
            {request.JobReference}
          </Link>,
          i18n.t("REQUESTSTATUS_" + request.Status),
          i18n.t("REQUESTTYPE_" + request.Type),
        ];
      }),
      classes: ["", "hidden md:table-cell", "", ""],
    };

    const currencies: TableInfo = {
      tableHeader: [i18n.t("LABEL_CURRENCY"), i18n.t("LABEL_BANK_RATE"), i18n.t("LABEL_ISK_CROSS")],
      tableData: this.props.latestCurrencies.map((currency) => {
        return [
          <div
            className={`currency-flag currency-flag-${currency.CurrencyCode.toLowerCase()} align-middle`}
            key={currency.CurrencyCode}
            title={currency.CurrencyCode}
          />,
          currency.BankRate.toFixed(2),
          currency.IskKross.toFixed(7),
        ];
      }),
      classes: ["", "", ""],
    };

    return (
      <Translation>
        {(t) => (
          <main className={`${styles.master} h-auto w-full flex content-center flex-grow flex-col`}>
            <div className="flex flex-wrap justify-center content-center xl:container w-full mx-auto py-8 px-4">
              <TableCard
                className="z-5 fade-in-left"
                createBookingLink={
                  AuthService.hasUserAccessToRoles([UserRole.CREATE, UserRole.SYSADMIN])
                    ? "/shipments/createairfreightbooking"
                    : undefined
                }
                freightMode={FreightMode.AI}
                hasAccess={AuthService.hasUserAccessToRoles([UserRole.AIR, UserRole.SYSADMIN])}
                hasSearch
                imageClass="bg-air-freight"
                loadingTable={this.props.loadingAirFreightBookings}
                noResultsMessage={t("WARNING_NO_VOYAGE_OR_AIR_BOOKING_FOUND")}
                searchPlaceholder={t("TEXT_VOYAGE_OR_AIR_BOOKING_NUMBER")}
                subTitle={
                  <>
                    {this.props.loadingAirFreightBookings ? (
                      <FaSpinner className="fa-spin inline" />
                    ) : (
                      this.props.activeAirFreightBookings.length
                    )}{" "}
                    {t("TEXT_ACTIVE_BOOKINGS", {
                      count: this.props.activeAirFreightBookings.length,
                    })}
                  </>
                }
                subTitleClick
                subTitleLink=""
                tableInfo={airTravel}
                tableTitle={t("LABEL_AIR_FREIGHT", {
                  count: this.props.activeAirFreightBookings.length,
                })}
                title={t("LABEL_AIR_FREIGHT")}
                tooltip={
                  <Trans
                    components={{ icon: <FiRefreshCcw className="inline" /> }}
                    i18nKey="TEXT_AIR_FREIGHT_TOOLTIP"
                  />
                }
              />
              <TableCard
                className="z-4 fade-in-right"
                createBookingLink={
                  AuthService.hasUserAccessToRoles([UserRole.CREATE, UserRole.SYSADMIN])
                    ? "/shipments/createseafreightbooking"
                    : undefined
                }
                freightMode={FreightMode.SH}
                hasAccess={AuthService.hasUserAccessToRoles([UserRole.SHIP, UserRole.SYSADMIN])}
                hasSearch
                imageClass="bg-sea-freight"
                loadingTable={this.props.loadingSeaFreightBookings}
                noResultsMessage={t("WARNING_NO_VOYAGE_OR_SEA_BOOKING_FOUND")}
                searchPlaceholder={t("TEXT_VOYAGE_OR_SEA_BOOKING_NUMBER")}
                subTitle={
                  <>
                    {this.props.loadingSeaFreightBookings ? (
                      <FaSpinner className="fa-spin inline" />
                    ) : (
                      this.props.activeSeaFreightBookings.length
                    )}{" "}
                    {t("TEXT_ACTIVE_BOOKINGS", {
                      count: this.props.activeSeaFreightBookings.length,
                    })}
                  </>
                }
                subTitleClick
                subTitleLink=""
                tableInfo={seaTravel}
                tableTitle={t("LABEL_SEA_FREIGHT", {
                  count: this.props.activeSeaFreightBookings.length,
                })}
                title={t("LABEL_SEA_FREIGHT")}
                tooltip={
                  <Trans
                    components={{ icon: <FiRefreshCcw className="inline" /> }}
                    i18nKey="TEXT_SEA_FREIGHT_TOOLTIP"
                  />
                }
              />
              <TableCard
                className="z-3 fade-in-left"
                hasAccess={AuthService.hasUserAccessToRoles([UserRole.REQUESTS, UserRole.SYSADMIN])}
                imageClass="bg-service-card"
                loadingTable={this.props.loadingRequests}
                noResultsMessage={t("WARNING_NO_BOOKING_OR_REQUEST_FOUND")}
                subTitle={t("LABEL_VIEW_ALL_REQUESTS")}
                subTitleClick={false}
                subTitleLink="/requests"
                tableInfo={requestTravel}
                tableTitle={t("LABEL_REQUEST", {
                  count: this.props.activeRequests.length,
                })}
                title={t("LABEL_MY_REQUESTS")}
                tooltip={
                  <Trans
                    components={{ icon: <FiRefreshCcw className="inline" /> }}
                    i18nKey="TEXT_REQUESTS_TOOLTIP"
                  />
                }
              />
              {this.props.userProfile &&
              this.props.userProfile.Access.UserType === UserType.EMPLOYEE ? (
                <TableCard
                  className="z-3 fade-in-right"
                  dateStamp={
                    this.props.latestCurrencies.length > 0
                      ? new Date(this.props.latestCurrencies[0].CurrencyDate)
                      : undefined
                  }
                  hasAccess
                  hasSearch={false}
                  imageClass="bg-currency-converter"
                  loadingTable={this.props.loadingCurrencies}
                  noResultsMessage={t("WARNING_NO_DATA_FOUND")}
                  subTitle={t("TEXT_VIEW_RATE")}
                  subTitleClick
                  subTitleLink=""
                  tableInfo={currencies}
                  tableTitle={t("LABEL_RATE_OF_EXCHANGE")}
                  title={t("LABEL_RATE_OF_EXCHANGE")}
                  tooltip={t("TEXT_RATE_OF_EXCHANGE_TOOLTIP")}
                />
              ) : null}
              <MapCard
                back
                className={`z-2 ${
                  this.props.userProfile &&
                  this.props.userProfile.Access.UserType !== UserType.EMPLOYEE
                    ? "fade-in-right"
                    : "fade-in-left"
                }`}
                flip={false}
                hasAccess
                imageClass="bg-harbour-card"
                subTitle={t("LABEL_VIEW_OPENINGHOURS")}
                subTitleClick={false}
                subTitleLink="https://www.jonar.is/upplysingar/erlendar-skrifstofur/"
                title={t("LABEL_HARBOUR_OPENING_HOURS")}
                tooltip={null}
              />
              <MapCard
                back={false}
                className={`z-2 ${
                  this.props.userProfile &&
                  this.props.userProfile.Access.UserType !== UserType.EMPLOYEE
                    ? "fade-in-bottom"
                    : "fade-in-right"
                }`}
                flip={false}
                hasAccess
                imageClass="bg-harbour-card"
                subTitle={t("LABEL_VIEW_OPENINGHOURS")}
                subTitleClick={false}
                subTitleLink="https://www.jonar.is/upplysingar/erlendar-skrifstofur/"
                title={t("LABEL_HARBOUR_OPENING_HOURS")}
                tooltip={null}
              />
            </div>
            <ContactButton
              onClick={() => {
                location.href = "mailto:jonar@jonar.is";
              }}
            />
          </main>
        )}
      </Translation>
    );
  }
}

export default connect(
  (state: AppState) => {
    return {
      activeRequests: state.HomeReducer.activeRequests,
      loadingRequests: state.HomeReducer.loadingRequests,
      activeSeaFreightBookings: state.HomeReducer.activeSeaFreightBookings,
      loadingSeaFreightBookings: state.HomeReducer.loadingSeaFreightBookings,
      activeAirFreightBookings: state.HomeReducer.activeAirFreightBookings,
      loadingAirFreightBookings: state.HomeReducer.loadingAirFreightBookings,
      latestCurrencies: state.HomeReducer.latestCurrencies,
      loadingCurrencies: state.HomeReducer.loadingCurrencies,
      userProfile: state.UserReducer.userProfile,
    };
  },
  {
    fetchActiveAirFreightBookings,
    fetchActiveSeaFreightBookings,
    fetchActiveRequests,
    fetchLatestCurrencies,
  }
)(Master);
